import React, { Component } from 'react'

/**
 * This class implements a file drag-and-drop.  It will only allow
 * a single 'text/csv' file to be dropped. 
 */
class DragAndDrop extends Component {
  state = {
    drag: false
  }
  dropRef = React.createRef()
  handleDrag = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }
  handleDragIn = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.dragCounter++;
    if (event.dataTransfer.items && event.dataTransfer.items.length === 1) {
      this.setState({ drag: true })
    }
  }
  handleDragOut = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.setState({ drag: false })
    }
  }
  handleDrop = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.setState({ drag: false })
    if (event.dataTransfer.files && event.dataTransfer.files.length === 1) {
      const files = event.dataTransfer.files;
      if (files[0].type === 'text/csv') {
        this.props.handleDrop(event.dataTransfer.files)
        event.dataTransfer.clearData()
        this.dragCounter = 0
      }
    }
  }
  componentDidMount() {
    let div = this.dropRef.current
    div.addEventListener('dragenter', this.handleDragIn)
    div.addEventListener('dragleave', this.handleDragOut)
    div.addEventListener('dragover', this.handleDrag)
    div.addEventListener('drop', this.handleDrop)
  }
  componentWillUnmount() {
    let div = this.dropRef.current
    div.removeEventListener('dragenter', this.handleDragIn)
    div.removeEventListener('dragleave', this.handleDragOut)
    div.removeEventListener('dragover', this.handleDrag)
    div.removeEventListener('drop', this.handleDrop)
  }
  render() {
    return (
      <div className={'drag-and-drop'}
        style={{ display: 'inline-block', position: 'relative' }}
        ref={this.dropRef}
      >
        {this.state.dragging &&
          <div
            style={{
              border: 'dashed grey 4px',
              backgroundColor: 'rgba(255,255,255,.8)',
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                right: 0,
                left: 0,
                textAlign: 'center',
                color: 'grey',
                fontSize: 36
              }}
            >
              <div>drop here :)</div>
            </div>
          </div>
        }
        {this.props.children}
      </div>
    )
  }
}
export default DragAndDrop